export default "__VITE_ASSET__FVa8qatN__"